
import { Getter } from 'vuex-class';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
    Logo: () => import('@/assets/svg/logo-small.svg'),
    Gears: () => import('@/assets/svg/gears.svg'),
    News: () => import('@/assets/svg/news.svg'),
    Questions: () => import('@/assets/svg/questions.svg'),
    Meter: () => import('@/assets/svg/meter.svg'),
    UserUserCircle: () => import('@/assets/svg/user-user-circle.svg'),
    UserCircleCheck: () => import('@/assets/svg/user-circle-check.svg'),
    UserLogOut: () => import('@/assets/svg/user-log-out.svg'),
    Dashboard: () => import('@/assets/svg/dashboard.svg'),
    ElLoader: () => import('@/components/forms/ElLoader.vue'),
  },
})
export default class PageDashboard extends Vue {
  @Getter('pageLoading') pageLoading!: boolean;

  @Getter('user/auth') me!: Auth;

  @Prop({ default: 300 }) sideWidth!: number;

  get hasHeader() {
    return !!this.$slots.header;
  }
  get hasRight() {
    return !!this.$slots.right;
  }
  get hasFooter() {
    return !!this.$slots.footer;
  }

  get bodyStyle() {
    if (this.hasRight) {
      return { width: `calc(100% - ${this.sideWidth}px)` };
    }
    return {};
  }

  get rightStyle() {
    if (this.hasRight) {
      return { width: `${this.sideWidth}px` };
    }
    return {};
  }
}
